<template>
  <EditCom
    :title="title"
    :target="target"
    :buttonList="buttonList"
    :inputList="inputList"
    :rules="rules"
    @closeFun="close"
  ></EditCom>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import EditCom from '@/components/EditCom';

import {
  putWorkspace,
} from '@/api/UserWorkspaceApi';
// props
const props = defineProps({
  title: { type: String, },
  target: { type: Object, },
});
// emit
const emit = defineEmits([
  'close', 'submitCallback',
]);

const close = ()=>{
  emit('close');
}

const target = ref({
  ...props.target,
});

const submitFn = (item, button, loadFn, fn)=>{
  // console.log(item);
  putWorkspace(item).then(res=>{
    if(res.data.code == 1004){
      close();
      emit('submitCallback');
    }
    loadFn && loadFn();
  }).catch(err=>{
    loadFn && loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn && loadFn();
    }
  });
};

const buttonList = ref([
  { name: '取消', fun: close, type: 'danger', },
  { name: '确定', fun: submit, type: 'primary', },
]);
const inputList = ref([
  { name: '快照名称', prop: 'name', type: 'text' },
]);
const rules = reactive({
  name: [
    { required: true, message: '请输入快照名称', trigger: 'blur' },
  ],
});

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>